import baseUrl from "@/api/base-url";

export default {
    checkoutKey: 'CHECKOUTURLKEY',
    formatUrl(url){
        if(!url.includes('https://')){
            url = window.location.origin + url;
        }
        return url;
    },
    goBack(defaultUrl = null, callBack = null){
        let referrer = document.referrer ?? null;
        let url = defaultUrl ?? baseUrl.getUrl('') ?? null;
        if(referrer && history.length > 1){
            let data = new URL(referrer);
            if( data && 
                window.location && 
                data.host == window.location.host
                // not go to checkout process
                && !referrer.includes('/checkout/')
                && !referrer.includes('/process/')
                ){
                url = null;
                if(callBack && typeof callBack === 'function'){
                    callBack();
                }
                history.back();
            }
        }
        if(url){
            if(callBack && typeof callBack === 'function'){
                callBack();
            }
            window.location.assign(url);
        }
    },
    checkoutEnter(){
        const storage  = window.sessionStorage ?? null;
        const referrer = document.referrer ?? null;
        const data     = referrer ? new URL(referrer) : null;
        if(storage && referrer && data               
            && !referrer.includes('/checkout/')
            && !referrer.includes('/process/')
            && data.host == window.location.host){
            
            storage.setItem(this.checkoutKey,referrer);
        }
    },
    checkoutLastReferrer(){
        const storage  = window.sessionStorage ?? null;
        return storage && storage.getItem(this.checkoutKey);
    },
    checkoutRemoveLastReferrer(){
        const storage  = window.sessionStorage ?? null;
        return storage && storage.removeItem(this.checkoutKey);
    }
}